<div>

    <div class="row m-0 p-0">

        <div class="col-md-12">
            <div class="closebtn hardclose" (click)="close()">
                <span class="material-icons">
                    close
                </span>
            </div>
            <div class="row">
                <div class="col-md-12">

                    <form [formGroup]="devlieryDateForm" >
                        <div class="form_full_course">
        
                           <h3>Delivery Address
                            </h3>
        
                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input type="text" matInput formControlName="address1" placeholder="Address 1">                                    
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input type="text" matInput formControlName="address2" placeholder="Address 2">                                    
                                </mat-form-field>
                            </div>
                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input type="text" matInput formControlName="state" placeholder="State">                                    
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input type="text"
                                    matInput
                                    formControlName="city" placeholder="City"
                                    [matAutocomplete]="auto"
                                    (keyup)="filter($event)">

                                    <mat-autocomplete  #auto="matAutocomplete">
                                        <mat-option *ngFor="let city of cityList" [value]="city.city_name">
                                         {{city.city_name}}
                                        </mat-option>
                                      </mat-autocomplete>

                                </mat-form-field>

                            
                            </div>

                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input type="text" matInput formControlName="pincode" placeholder="Pincode">                                    
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input formControlName="alternate_phone_number" matInput placeholder="Alternate Phone number"
                                        minlength="10" maxlength="10">
                                </mat-form-field>
                            </div>


                            <button class="mt-3"  mat-flat-button color="primary"
                                (click)="save()">Submit</button>
        
                        </div>
                    </form>
                </div>

                
            </div>
           

        </div>

    </div>

</div>